import * as _ from './default.json'

export default {
  iconfont: 'md',
  theme: {
    primary: _.$primary, // '#0C5689',
    secondary: _.$secondary,
    accent: _.$accent,
    success: _.$success,
    warning: _.$warning,
    error: _.$error,
    info: _.$info
  }
}
